import { AxiosError } from 'axios';
import { classifyError } from 'utils/classifyError';
import { UserFacingError } from 'utils/errorMessages';

export type { UserFacingError } from 'utils/errorMessages';
export {
  isBrowserTranslatorActive,
  isTranslatorRelatedError,
  resolveAxiosUserMessage,
  resolveRuntimeUserMessage,
  resolveTranslatorUserMessage,
} from 'utils/errorMessages';

export function getUserFacingError(error: unknown): UserFacingError {
  return classifyError(error).userMessage;
}

export function isSanctionedAccountError(error: unknown): boolean {
  if (!(error instanceof AxiosError)) {
    return false;
  }

  const sanctionedMessageList = [
    'Your account is pending approval',
    'Your account has been rejected',
  ];

  return (
    error.response?.status === 403 &&
    sanctionedMessageList.includes((error.response?.data as { message: string })?.message)
  );
}
